module.exports = __webpack_public_path__ + "static/media/gintonic.5f2d7b5f.png";